import { Link } from '@loadsmart/loadsmart-ui'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { TradingPartner } from 'common/types/kraken-core/TradingPartner'

export interface LinkToPartnerProps {
  partner: TradingPartner
  label?: string
}

export default function LinkToParnter(props: LinkToPartnerProps) {
  const partner = props.partner
  const name =
    partner.name && partner.name?.length > 20
      ? partner.name.slice(0, 20).concat('...')
      : partner.name
  return (
    <Link href={`/trading-partner/${partner.id}`}>
      <span className="inline-flex items-center gap-2">
        {props.label || name}
        <OpenInNewIcon fontSize="inherit" />
      </span>
    </Link>
  )
}
